import Image from 'next/image';
import styled from 'styled-components';
import { TidalTag } from '../../common/tag';

const TidalDashboardUpdateCardWrapper = styled.div`
  box-shadow: 0px 19px 42px rgba(0, 27, 31, 0.08);
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.background};
  margin-bottom: 24px;
  border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  @media only screen and (max-width: 800px) {
    box-shadow: 0 0 0;
  }
  span > img {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    height: 168px;
    width: 100%;
    object-fit: cover;
  }
  & > .body {
    padding: 24px 30px;
    @media only screen and (max-width: 800px) {
      padding: 16px;
    }
    & > .title-row {
      display: grid;
      grid-template-columns: 1fr 55px;
      grid-gap: 5px;
      p {
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: ${(props) => props.theme.colors.text[1]};
      }
    }
    & > .description {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: ${(props) => props.theme.colors.text[0]};
      margin-top: 13px;
    }

    & > .action {
      color: ${(props) => props.theme.colors.accent};
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      margin-top: 13px;
    }
  }
`;

interface ITidalDashboardUpdateCard {
  image: string;
  title: string;
  description: string;
  action?: string;
  isNew: boolean;
}

const TidalDashboardUpdateCard = ({
  image,
  title,
  description,
  action,
  isNew,
}: ITidalDashboardUpdateCard): JSX.Element => {
  return (
    <TidalDashboardUpdateCardWrapper>
      <Image
        alt="update card"
        src={image}
        height={125}
        width={250}
        className="cover-img"
        layout="responsive"
      />
      {/* <img alt="" src={image} className="cover-img" /> */}
      <div className="body">
        <div className="title-row">
          <p>{title}</p>
          {isNew && <TidalTag type="info" title="NEW" />}
        </div>
        <p className="description">{description}</p>
        {action && <button className="action">{action}</button>}
      </div>
    </TidalDashboardUpdateCardWrapper>
  );
};

export default TidalDashboardUpdateCard;
